import { render, staticRenderFns } from "./EntitiesTable.vue?vue&type=template&id=971bf244&scoped=true&lang=pug&"
import script from "./EntitiesTable.vue?vue&type=script&lang=js&"
export * from "./EntitiesTable.vue?vue&type=script&lang=js&"
import style0 from "./EntitiesTable.vue?vue&type=style&index=0&id=971bf244&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971bf244",
  null
  
)

export default component.exports